<template>
    <section class="my-16 px-6">
        <div class="container mx-auto">
            <h3>Reviews</h3>

            <div class="grid lg:grid-cols-2 gap-12 mt-4 mb-6">
                <slot></slot>

                <div v-for="review in reviews">
                    <p class="font-semibold text-gray-700">
                        {{ review.seat.customer.first_name }} {{ review.seat.customer.last_name }}
                    </p>

                    <p class="text-sm text-primary-600">
                        {{ review.event_date.event_date }}
                    </p>

                    <div class="my-2"
                         v-html="review.body"
                    ></div>

                    <div class="flex text-primary-600">
                        <svg fill="currentColor"
                             viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg"
                             class="w-5 h-5"
                             v-for="n in review.rating"
                        >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                    </div>

                    <div class="px-6 text-gray-500 mt-3 text-sm"
                         v-if="review.response"
                    >
                        <div v-html="review.response"></div>

                        <p class="font-semibold mt-1">
                            Nomad
                        </p>
                    </div>
                </div>
            </div>

            <div class="flex justify-center">
                <form-button @click.native="loadMore"
                             v-if="showLoadButton"
                >
                    Load More
                </form-button>
            </div>
        </div>
    </section>
</template>

<script>
    import FormButton from "./form/public/Button";

	export default {
        data() {
            return {
                reviews: [],

                currentPage: 1,
                pages: 1,
                perPage: 4,

                loading: false,
            }
        },

        props: {
            eventId: {
                type: Number,
                required: true,
            }
        },

        components: { FormButton },

        mounted() {
            axios.get(`/reviews/${this.eventId}/count`)
                .then(response => {
                    this.pages = response.data;
                })
        },

        computed: {
            showLoadButton() {
                return this.currentPage < this.pages;
            }
        },

        methods: {
            loadMore() {
                console.log('test');
                if (this.loading) return false;

                this.loading = true;

                axios.post(`/reviews/${this.eventId}`, { page: this.currentPage + 1 })
                    .then(response => {
                        this.reviews = this.reviews.concat(response.data);
                        this.loading = false;
                        this.currentPage++;
                    })
            }
        }
    }
</script>
